<!--
 * @Desc: 
 * @Author: lc
 * @Date: 2023-06-06 10:09:24
 * @LastEditors: lc
 * @LastEditTime: 2023-06-06 16:05:04
-->
<template>
  <div class="app-container">
    <!-- $t is vue-i18n global function to translate lang -->
    <el-input v-model="filename"
              :placeholder="$t('zip.placeholder')"
              style="width:300px;"
              prefix-icon="el-icon-document" />
    <el-button :loading="downloadLoading"
               style="margin-bottom:20px;"
               type="primary"
               icon="document"
               @click="handleDownload">
      {{ $t('zip.export') }} zip
    </el-button>
    <el-table v-loading="listLoading"
              :data="list"
              element-loading-text="拼命加载中"
              border
              fit
              highlight-current-row>
      <el-table-column align="center"
                       label="ID"
                       width="95">
        <template slot-scope="scope">
          {{ scope.$index }}
        </template>
      </el-table-column>
      <el-table-column label="Title">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>
      <el-table-column label="Author"
                       width="95"
                       align="center">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.author }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Readings"
                       width="115"
                       align="center">
        <template slot-scope="scope">
          {{ scope.row.pageviews }}
        </template>
      </el-table-column>
      <el-table-column align="center"
                       label="Date"
                       width="220">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.display_time }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { fetchList } from '@/api/console/Article'

export default {
  name: 'ExportZip',
  data () {
    return {
      list: null,
      listLoading: true,
      downloadLoading: false,
      filename: ''
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      this.listLoading = true
      const { data } = await fetchList()
      this.list = data.items
      this.listLoading = false
    },
    handleDownload () {
      this.downloadLoading = true
      import('@/vendor/Export2Zip').then(zip => {
        const tHeader = ['Id', 'Title', 'Author', 'Readings', 'Date']
        const filterVal = ['id', 'title', 'author', 'pageviews', 'display_time']
        const list = this.list
        const data = this.formatJson(filterVal, list)
        zip.export_txt_to_zip(tHeader, data, this.filename, this.filename)
        this.downloadLoading = false
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
}
</script>
